import { clearXml } from '@/app/store/GlobalStoreUtils'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

let webSocket = new WebSocket('wss://127.0.0.1:13579/')
const socketUrl = 'wss://127.0.0.1:13579/'

export function blockScreen() {
	const overlay = document.createElement('div')
	overlay.setAttribute('id', 'blockUIOverlay')
	document.body.appendChild(overlay)
	overlay.innerHTML = `<img src="lib/loading.gif" style={{width: '30%' height: '30%'}}/><br/>${'Подождите, выполняется операция в NCALayer...'}`
	overlay.style.display = 'block'
	overlay.style.position = 'fixed'
	overlay.style.top = '0'
	overlay.style.left = '0'
	overlay.style.width = '100%'
	overlay.style.height = '100%'
	overlay.style.background = 'rgba(0, 0, 0, 0.5)'
	overlay.style.color = '#fff'
	overlay.style.textAlign = 'center'
	overlay.style.paddingTop = '20%'
	overlay.style.zIndex = '5000'
}
export function unblockScreen() {
	const overlay = document.getElementById('blockUIOverlay')
	if (overlay) {
		overlay.remove()
	}
}

export const useDigitalSign = () => {
	const { t } = useTranslation()
	const [successPayload, setSuccessPayload] = useState(null)
	const [ecpInfo, setEcpInfo] = useState(null)
	const [failedPayload, setFailedPayload] = useState(null)
	const [actionType, setActionType] = useState(null)

	const dispatch = useDispatch()

	const startSocket = function (callback) {
		callback = callback || function () {}

		if (!webSocket || webSocket.readyState !== webSocket.OPEN) {
			//веб сокет успешно запущен
			webSocket = new WebSocket(socketUrl)

			webSocket.onopen = function (event) {
				callback(event)
			}
		}

		//веб сокет сломался
		webSocket.onclose = function (event) {
			if (!event.wasClean) {
				setFailedPayload(event.timeStamp)
				alert(t('ncalayer_info'))
			}
		}
	}

	useEffect(() => {
		webSocket.onmessage = function (event) {
			const result = JSON.parse(event.data)
			if (result) {
				// Универсальный разбор: новый формат (status/body.result) и старый (code/responseObject)
				let responseObject =
					result.body?.result !== undefined
						? result.body.result
						: result.responseObject !== undefined
						? result.responseObject
						: result.body

				// Если это одиночная подпись — брать первый элемент массива
				if (Array.isArray(responseObject) && responseObject.length > 0 && actionType !== 'signMultiple') {
					responseObject = responseObject[0]
				}

				const normalizedStatus = typeof result.status !== 'undefined' ? result.status : String(result.code) === '200'
				const normalizedMessage = result.message || result['message']

				const data = {
					status: normalizedStatus,
					message: normalizedMessage,
					responseObject: responseObject,
					getResult: function () {
						return this.result
					},
					getMessage: function () {
						return this.message
					},
					getResponseObject: function () {
						return this.responseObject
					},
					getCode: function () {
						return this.code
					},
				}

				unblockScreen()
				// В новой библиотеке отмена может прийти как status=true при пустом body — считаем это ошибкой
				const isCancelForSign =
					(actionType === 'sign' || actionType === 'signMultiple') &&
					responseObject &&
					typeof responseObject === 'object' &&
					!Array.isArray(responseObject) &&
					Object.keys(responseObject).length === 0

				if (!data.status || isCancelForSign) {
					setFailedPayload({ message: data.message || 'action.canceled' })
				} else {
					if (actionType === 'info') {
						setEcpInfo(responseObject)
					} else if (actionType === 'sign' || actionType === 'signMultiple') {
						setSuccessPayload(responseObject)
					}
				}
			}
		}
	}, [actionType])

	const onSign = useCallback((dataToSign) => {
		if (!webSocket || webSocket.readyState !== webSocket.OPEN) {
			startSocket(function () {
				onSign(dataToSign)
			})
			return
		}
		blockScreen()
		const signXml = {
			module: 'kz.gov.pki.knca.basics',
			method: 'sign',
			args: {
				allowedStorages: ['PKCS12'],
				signingParams: {},
				signerParams: { extKeyUsageOids: ['1.3.6.1.5.5.7.3.4'] },
				format: 'xml',
				data: dataToSign,
				locale: 'ru',
			},
		}
		setActionType('sign')
		webSocket.send(JSON.stringify(signXml))
	}, [])

	const onSignMultiple = useCallback((dataToSign, callback) => {
		if (!webSocket || webSocket.readyState !== webSocket.OPEN) {
			startSocket(function () {
				onSignMultiple(dataToSign, callback)
			})
			return
		}
		blockScreen()
		const signXmls = {
			module: 'kz.gov.pki.knca.basics',
			method: 'sign',
			args: {
				allowedStorages: ['PKCS12'],
				signingParams: {},
				signerParams: { extKeyUsageOids: ['1.3.6.1.5.5.7.3.4'] },
				format: 'xml',
				data: dataToSign,
				locale: 'ru',
			},
		}
		setActionType('signMultiple')
		webSocket.send(JSON.stringify(signXmls))
	}, [])

	const getKeyInfoCall = useCallback((callback) => {
		if (!webSocket || webSocket.readyState !== webSocket.OPEN) {
			startSocket(function () {
				getKeyInfoCall(callback)
			})
			return
		}
		blockScreen()
		const getKeyInfo = {
			module: 'kz.gov.pki.knca.commonUtils',
			method: 'getKeyInfo',
			args: ['PKCS12'],
		}
		setActionType('info')
		try {
			webSocket.send(JSON.stringify(getKeyInfo))
		} catch (e) {
			unblockScreen()
			setFailedPayload({ message: e?.message || 'send error' })
		}
	}, [])

	const onClearPayload = useCallback(() => {
		setSuccessPayload(null)
		setEcpInfo(null)
		setActionType(null)
	}, [])

	useEffect(() => {
		return () => dispatch(clearXml())
	}, [successPayload])

	return {
		successPayload,
		failedPayload,
		onSign,
		onClearPayload,
		getKeyInfoCall,
		ecpInfo,
		onSignMultiple,
	}
}
